import { Box, Card, styled } from '@mui/material';

const FullWidth = styled(Box)(() => ({
  width: '100%',
}));

const ArrayCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(1.5),
  border: '1px solid #e0e0e0',
}));

const ItemBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(2),
  alignItems: 'flex-start',
}));

export { FullWidth, ArrayCard, ItemBox };
